<template>
	<div class="clients-panel">
		<clients-panel-filters
			v-model="filters.searchStr"
			:selected-tags="selectedTags"
			@on-search="searchClients"
			@update:selected-tags="onSelectedTagsUpdate"
			@drop-tag="dropTag"
		/>
		<clients-panel-list
			@on-get-partial="fetchPartial"
			:search-text="appliedSearchText"
		/>
	</div>
</template>

<script setup lang="ts">
import {
	onMounted,
	ref
} from "vue";
import ClientsPanelFilters from "@/components/main/clients-panel/ClientsPanelFilters.vue";
import ClientsPanelList from "@/components/main/clients-panel/ClientsPanelList.vue";
import {
	ClientRequestData,
	clientsStore
} from "@/store/clients";
import { provideContactsContext } from "@/composables/useContactsContext";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { RequestAddressContainer } from "@/composables/useAddressRequest";

const cStore = clientsStore()

provideContactsContext({ context: 'main' })
const filters = ref<ClientRequestData>({
	searchStr: '',
	inputContainer: null,
	tags: [],
	toSkip: 0,
	count: 30
})
const selectedTags = ref<TagWithFrequency[]>([])
const appliedSearchText = ref('')

onMounted(async () => {
	await searchClients()
})

const searchClients = async (address?: RequestAddressContainer | null) => {
	if (address !== undefined) {
		filters.value.inputContainer = address
	}
	filters.value.toSkip = 0
	filters.value.tags = selectedTags.value.map(t => t.Id)
	appliedSearchText.value = filters.value.searchStr
	await cStore.fetchClients(filters.value)
}

const fetchPartial = async () => {
	filters.value.toSkip += 30
	await cStore.fetchClients(filters.value)
}

const onSelectedTagsUpdate = (next: TagWithFrequency[]) => {
	const wasEmpty = !selectedTags.value.length
	selectedTags.value = next
	if (!next.length && !wasEmpty) {
		searchClients()
	}
}

const dropTag = (tag: TagWithFrequency) => {
	selectedTags.value = selectedTags.value.filter(t => t.Id !== tag.Id)
	if (!selectedTags.value.length) {
		searchClients()
	}
}
</script>

<style scoped lang="scss">
.clients-panel {
	display: flex;
	flex-direction: column;
	max-height: 100%;
	height: 100%;
	width: 100%;
}
</style>
